import Grid from '@material-ui/core/Grid'
import React from 'react'

import { SanityHeroTextOptionDocument } from '../../../../../../../groq/sanity-dispensaries/types'
import TextField from '../../../../../../form/TextField'
import DispensaryBannerTextDisclaimer from '../DispensaryBannerTextDisclaimer'
import * as Styled from './styled'

export interface HeroTextCreateProps {
  optionForSlug: SanityHeroTextOptionDocument | null
}

const HeroTextCreate: React.FC<HeroTextCreateProps> = ({ optionForSlug }) => {
  return (
    <Styled.StyledGrid container spacing={5}>
      <Grid item xs={12}>
        <TextField
          label="Paragraph Text"
          name="text"
          defaultValue={optionForSlug?.text}
          rules={{
            maxLength: { value: 100, message: 'Text exceeds maximum length.' },
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Button Text"
          name="ctaText"
          defaultValue={optionForSlug?.ctaText}
          rules={{
            maxLength: { value: 20, message: 'Button text exceeds maximum length.' },
          }}
          fullWidth
        />
      </Grid>
      <DispensaryBannerTextDisclaimer />
    </Styled.StyledGrid>
  )
}

export default HeroTextCreate
